// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2amgk","col":"styles_col__bGE0m"};